module.exports = __webpack_public_path__ + "img/sessions.94171c08.svg";